import { FormWithRedux } from '../../FormWithRedux';
import { OsteoporosisIntroForm } from '../IntroForm/Osteoporosis-IntroForm';
import { OsteoporosisResultsForm } from '../ResultsForm/Osteoporosis-ResultsForm';
import { OsteoporosisPatientDetailsForm } from '../PatientDetails/Osteoporosis-PatientDetails';
import { OsteoporosisRequestCriteriaForm } from '../RequestCriteria/Osteoporosis-RequestCriteria';
import { OsteoporosisFurtherInformationForm } from '../FurtherInformation/Osteoporosis-FurtherInformation';
import { OsteoporosisActions } from '../Actions/Osteoporosis-Actions';
import { OsteoporosisDependantValuesUpdater } from '../Calculations/Osteoporosis-DependantValuesUpdater';
import { OsteoporosisCalculations } from '../Calculations/Osteoporosis-Calculations';

export class OsteoporosisMainForm extends FormWithRedux {

    constructor() {
        super('mainForm', null, new OsteoporosisActions(), new OsteoporosisDependantValuesUpdater(), new OsteoporosisCalculations());
    }

    generateSubform(identifier) {
        switch (identifier) {
            case 'introForm':
                return new OsteoporosisIntroForm();
            case 'resultsForm':
                return new OsteoporosisResultsForm(this, this.actionUpdater, this.dependentValuesUpdater, this.calculationsUpdater);
            case 'patientDetails':
                return new OsteoporosisPatientDetailsForm(this, this.actionUpdater, this.dependentValuesUpdater, this.calculationsUpdater);
            case 'requestCriteria':
                return new OsteoporosisRequestCriteriaForm(this, this.actionUpdater, this.dependentValuesUpdater, this.calculationsUpdater);
            case 'furtherInformation':
                return new OsteoporosisFurtherInformationForm(this, this.actionUpdater, this.dependentValuesUpdater, this.calculationsUpdater);
        }
    }

    shouldDisplayFormDetailForIdentifier(identifier) {
        super.shouldDisplayFormDetailForIdentifier(identifier);
        return true;
    }

    isEnabled(identifier) {
        if (identifier != null) {
            return true;
        }
        return false;
    }

    isMandatory() {
        return false;
    }

    getValueType() {
        return null;
    }

    submissionValidation() {
        return [];
    }

    detailString() {
        return this.detail;
    }
}


// WEBPACK FOOTER //
// ./src/forms/dxaScan01/MainForm/Osteoporosis-MainForm.js